module.exports = __webpack_public_path__ + "static/media/5.841b9b2a.jpg";